import QueryString from "qs";
import { getErrorss } from "../../../functions/errors/GetErrors"
import { unitsPopulate } from "../../../functions/shared/api/queries/getQueryUnits";
import { ACCESS_KEY, urlAPI, USER_ID_KEY } from "../../../urls"
import { dataFetchingFinish, dataFetchingStart } from "../../slices/modalSlice"
import { type AppDispatch, type RootState } from "../../store"
import dayjs from 'dayjs'

export const fetchOccupiedPlaces = async (date: string) => {
    const jwt = window.localStorage.getItem(ACCESS_KEY) ?? '';
    const searchQuery = {
        sort: {},
        populate: unitsPopulate,
        filters: {
            $and: [
                {
                    PublishedDate: {
                        $eq: dayjs(date).toISOString(), // Преобразуем дату в ISO формат
                    },
                },
                {
                    PublishedPlace: {
                        $notNull: true, 
                    },
                },
            ],
        },
    };

    const response = await fetch(`${urlAPI}`, {
        method: 'POST',
        headers: {
            'Content-Type': 'application/json',
            Authorization: `Bearer ${jwt}`,
        },
        body: JSON.stringify({
            method: 'GET',
            collection: 'units',
            query: QueryString.stringify(searchQuery, {
                encodeValuesOnly: true,
            }),
        }),
    });

    const result = await response.json();
    return result;
};

















export const publishUnitWithBuyPlace = (unitID : number, place: number | null , data : string ) => async (dispatch: AppDispatch, getState: () => RootState): Promise<any> => {
    const jwt = window.localStorage.getItem(ACCESS_KEY) ?? ''
    const userID = window.localStorage.getItem(USER_ID_KEY) ?? '' 
 
    console.log(place, "place")

    try {
        dispatch(dataFetchingStart())


        const response = await fetch(`${urlAPI}`, {
            method: 'POST',
            headers: {
                'Content-Type': 'application/json',
                Authorization: `Bearer ${jwt}`,
            },
            body: JSON.stringify({
                method: 'PUT',
                collection: 'units',
                id: unitID,
                body: {
                    ...(place !== null && place > 0 ? {
                        PublishedDate: data,
                        PublishedPlace: place
                    } : {}),
                    Statuses: ['Door close', 'Agent Unit']
                }
            }),

        })

        const  responseJSON = await response.json()
        if (responseJSON.success) {
            if (responseJSON.response.error != null) {
                dispatch(dataFetchingFinish())
                return { textNavigate: '', isSuccessful: false, textNotification: getErrorss(responseJSON) }
            } else {    
                
                
                // const { isSuccessful } = dispatch(singleUnitFetchingSuccess(responseJSON))
                // if (!isSuccessful) {
                //     await dispatch(fetchUnits(true))
                //     await dispatch(fetchUser(true))
                // }
                // dispatch(setDebitMarketingCredits(0))
                // dispatch(setNotEnoughMarketingCredits(0))
                // const inMoment = toUTCWithOffset(getCurrentDubaiDate(), 1)
                // const today = dayjs()
                // const futureDate = today.add(Number(1), 'day').toDate()
                // const inFuture = toUTCWithOffset(futureDate, 1)

                // await sendNotification(inMoment, Number(userID), Number(unitID), 'user-unit-broadcast', 'user unit broadcast notify')
                // await sendNotification(inFuture, Number(userID), Number(unitID), 'user-unit-broadcast-end', 'user unit broadcast end notify')
                // void sendUnitNotification(responseJSON.response.data, 'user-unit-new')
 

                dispatch(dataFetchingFinish())
                return {
                    ...responseJSON,
                    textNavigate: ``,
                    isSuccessful: true,
                    textNotification: 'Unit has been published successfully'
                }
            }
        } else {
            dispatch(dataFetchingFinish())
            return { textNavigate: '', isSuccessful: false, textNotification: getErrorss(responseJSON) }
        }
    } catch (error) {
        dispatch(dataFetchingFinish())
        return { textNavigate: '', isSuccessful: false, textNotification: getErrorss("error") }
    }

}


       